module.exports = __webpack_public_path__ + "static/media/organization--mobile.eee5feb9.png";